import { createContext, useContext, useMemo } from 'react';
import { ORGANIZATION_TYPES } from 'src/constants/organizations';
import { detectTenantType } from 'src/utils/tenant-detection';
import { getTenantConfig } from 'src/constants/tenant-config';

export const TenantContext = createContext();

export const TenantContextProvider = ({ children }) => {
  const tenantType = useMemo(() => detectTenantType(), []);
  console.log("🚀 ~ TenantContextProvider ~ tenantType:", tenantType)
  const tenantConfig = useMemo(() => getTenantConfig(tenantType), [tenantType]);

  const value = useMemo(
    () => ({
      tenantType,
      ...tenantConfig,
      isCampaign: tenantType === 'campaign',
      isLegislative: tenantType === 'legislative',
      // Org type this tenant's data belongs to — used to scope superadmin
      // cross-org fetches (tags/notes/activity/bills) to the current tenant.
      orgTypeId:
        tenantType === 'legislative'
          ? ORGANIZATION_TYPES.LEGISLATIVE
          : ORGANIZATION_TYPES.CAMPAIGN,
    }),
    [tenantType, tenantConfig]
  );

  return <TenantContext.Provider value={value}>{children}</TenantContext.Provider>;
};

export const useTenantConfig = () => {
  const context = useContext(TenantContext);
  if (!context) {
    throw new Error('useTenantConfig must be used within TenantContextProvider');
  }
  return context;
};
